module.exports = __webpack_public_path__ + "assets/iti-ico-pickdate.d3a71ba2.svg";